import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'app/_services/notification.service';
import { SiteAssetsService } from 'app/_services/site-assets.service';
import { SiteWorkOrdersService } from 'app/_services/site-work-orders.service';

@Component({
  selector: 'choose-work-order-modal',
  templateUrl: './choose-work-order-modal.component.html',
})
export class ChooseWorkOrderModalComponent implements OnInit {
  @Input() site: any;
  @Input() workOrder: any;
  @Input() isSiteSession: boolean;

  public form: FormGroup;
  public assets: any[] = [];
  public workOrders: any[] = [];

  public isWorkOrdersLoading: boolean = false;
  private justOpened = true;

  constructor(
    private activeModal: NgbActiveModal,
    private notificationService: NotificationService,
    private siteAssetsService: SiteAssetsService,
    private workOrderService: SiteWorkOrdersService,
    private formBuilder: FormBuilder,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      isSiteSession: new FormControl(false),
      asset: new FormControl(),
      workOrder: new FormControl(),
    });

    this.setupPage();
  }

  private setupPage() {
    if (this.isSiteSession) {
      this.form.patchValue({
        isSiteSession: this.isSiteSession,
      });
    }

    if (this.workOrder) {
      this.form.patchValue({
        asset: {
          label: this.workOrder.asset.name,
          value: this.workOrder.asset.id,
          locked: this.workOrder.asset.locked,
        },
      });

      this.onSelectedAssetChange();
    }

    this.getAssetsForSite();
  }

  private getAssetsForSite() {
    this.assets = [];
    this.siteAssetsService.getAllSiteAssetsNoPagination(this.site.id).subscribe((data: any) => {
      data.forEach((element) => {
        const asset = {
          label: element.name,
          value: element.id,
          locked: element.locked,
        };
        this.assets.push(asset);
      });
    });
  }

  public onSelectedAssetChange() {
    this.isWorkOrdersLoading = true;

    this.form.patchValue({'workOrder': null});
    this.workOrders = [];
    this.workOrderService.getAllApprovedWorkOrdersByAsset(this.form.value.asset.value).subscribe((data: any) => {
      data.forEach((element) => {
        const item: any = {
          label: 'WRK' + element.id + ' ' + element.description,
          value: element,
          disabled: !(!this.form.value.asset.locked || element.status === 'OPEN'),
        };
        this.workOrders.push(item);

      });

      this.setWorkOrderInDropdownOnFirstLoad();

      this.isWorkOrdersLoading = false;
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Error', 'Could not load work order list');
      this.isWorkOrdersLoading = false;
    });
  }

  private setWorkOrderInDropdownOnFirstLoad() {
    if (this.justOpened) {
      if (this.workOrder) {
        let selectedOption = this.workOrders.find(wo => wo.value.id === this.workOrder.id);
        if (selectedOption) {
          this.form.patchValue({ 'workOrder': selectedOption.value });
        }
      }
      this.justOpened = false;
    }
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public onSubmit() {
    const values = this.form.value;

    this.activeModal.close({
      workOrder: !values.isSiteSession ? values.workOrder : null,
      isSiteSession: values.isSiteSession,
    });
  }
}
